import { fetchApi } from '../../lib/fetchApi';
import { SurveysHistoryCSV } from '../../features/historicalData/types';
import { buildCsvContent, downloadCsvFile } from '../../utils/downloadCsvFile';
import { formatDateToCompactYYYYMMDD } from '../../utils/formatters/DateFormatter';
import { DownloadCsvSource } from '../../types/DownloadCsvTypes';

export const saveCSV = async (body: SurveysHistoryCSV): Promise<void> => {
    try {
        const response = await fetchApi.post<DownloadCsvSource>('/surveys/convertCsv', body, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        // Try to find the data
        let arrayBufferData = response;
        if (!arrayBufferData) {
            // Maybe it's directly in response?
            if (response instanceof ArrayBuffer) {
                arrayBufferData = response;
            }
        }

        if (!arrayBufferData) {
            throw new Error('No ArrayBuffer data found in response');
        }

        const defaultFilename = 'craiteria_historical'; // Base name

        // Combine base name, date, and user input if any
        const finalFilename = `${defaultFilename}_${formatDateToCompactYYYYMMDD()}.csv`;
        downloadCsvFile(arrayBufferData, finalFilename);

    } catch (error) {
        console.error('Error downloading CSV:', error);
        throw error;
    }
};

export const downloadCsvTemplate = (headers: string[], fileName: string): void => {
    const csvContent = buildCsvContent(headers, [], () => [], false, true);
    downloadCsvFile(csvContent, fileName);
};
